import axios, {
  AxiosInstance,
  AxiosInterceptorManager,
  AxiosResponse
} from "axios";
import BigIntJsonService from "./bigIntJson";
import { MockCheckApi } from "@common/service/base-service/request/mockCheck";
export class RequestBaseService {
  axios: AxiosInstance;
  _requestInterceptors: Function | null = null;
  constructor() {
    axios.defaults.withCredentials = true;
    this.axios = axios.create({
      transformResponse: [
        function(data) {
          if (data[0] == "{") {
            return BigIntJsonService.parse(data);
          } else {
            return data;
          }
        }
      ]
      // withCredentials: true
    });
  }
  static isBlob(data) {
    return Object.prototype.toString.call(data) === "[object Blob]";
  }
  setRequestInterceptors(fn: Function) {
    // //
    this.axios.interceptors.request.use(
      config => {
        //- 统一去除url中的 //
        MockCheckApi.isSetLocalHost(config);
        config.url = config.url?.replace(/\/\//g, "/");
        fn && fn(config);
        return config;
      },
      function(error) {
        return Promise.reject(error);
      }
    );
  }
  setResponseInterceptors(fn: Function) {
    this.axios.interceptors.response.use(
      response => {
        if (RequestBaseService.isBlob(response)) {
          return response;
        }
        const customRes = fn && fn(response);
        const res = response.data || response;
        return customRes || res;
      },
      function(error) {
        return Promise.reject(error);
      }
    );
  }
}
